import React from 'react';
import { useTranslation } from 'react-i18next';

const Legal: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">        
        <section className="legal-section">
          <h2>{t('legal.section1.title')}</h2>
          <p><strong>{t('legal.section1.companyName')}</strong></p>

          <p><strong>{t('legal.section1.legalForm')}</strong> {t('legal.section1.legalFormValue')}</p>
          <p><strong>{t('legal.section1.activity')}</strong> {t('legal.section1.activityValue')}</p>
          <p><strong>{t('legal.section1.capital')}</strong> {t('legal.section1.capitalValue')}</p>
          <p><strong>{t('legal.section1.address')}</strong> {t('legal.section1.addressValue')}</p>
          <p><strong>{t('legal.section1.registrationNumber')}</strong> {t('legal.section1.registrationNumberValue')}</p>
          <p><strong>{t('legal.section1.siret')}</strong> {t('legal.section1.siretValue')}</p>
          <p><strong>{t('legal.section1.vat')}</strong> {t('legal.section1.vatValue')}</p>
          <p><strong>{t('legal.section1.rcs')}</strong> {t('legal.section1.rcsValue')}</p>
          <p><strong>{t('legal.section1.email')}</strong> {t('legal.section1.emailValue')}</p>
          <p><strong>{t('legal.section1.director')}</strong> {t('legal.section1.directorValue')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section2.title')}</h2>
          <p><strong>{t('legal.section2.host')}</strong> {t('legal.section2.hostValue')}</p>
          <p><strong>{t('legal.section2.hostLegalForm')}</strong> {t('legal.section2.hostLegalFormValue')}</p>
          <p><strong>{t('legal.section2.hostAddress')}</strong> {t('legal.section2.hostAddressValue')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section3.title')}</h2>
          <p>{t('legal.section3.text1')}</p>
          <p>{t('legal.section3.text2')}</p>
          <p>
            {t('legal.section3.text3')}{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              {t('legal.section3.privacyRules')}
            </a>{' '}
            {t('legal.section3.and')}{' '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
              {t('legal.section3.termsOfUse')}
            </a>{' '}
            {t('legal.section3.ofGoogle')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section4.title')}</h2>
          <p>{t('legal.section4.text1')}</p>
          <p>{t('legal.section4.text2')}</p>
          <p>{t('legal.section4.text3')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section5.title')}</h2>
          <p>{t('legal.section5.text1')}</p>
          <p><strong>{t('legal.section5.purposesTitle')}</strong></p>
          <p>{t('legal.section5.purpose1')}</p>
          <p>{t('legal.section5.purpose2')}</p>
          <p>{t('legal.section5.purpose3')}</p>
          <p>{t('legal.section5.purpose4')}</p>
          <p>{t('legal.section5.legalBasisText')}</p>
          <p>{t('legal.section5.contactManagement')}</p>
          <p><strong>{t('legal.section5.legalBasis1Title')}</strong> {t('legal.section5.legalBasis1Text')}</p>
          <p>{t('legal.section5.userExperience')}</p>
          <p><strong>{t('legal.section5.legalBasis2Title')}</strong> {t('legal.section5.legalBasis2Text')}</p>
          <p>{t('legal.section5.formSecurity')}</p>
          <p><strong>{t('legal.section5.legalBasis3Title')}</strong> {t('legal.section5.legalBasis3Text')}</p>
          <p>{t('legal.section5.technicalOperation')}</p>
          <p><strong>{t('legal.section5.legalBasis4Title')}</strong> {t('legal.section5.legalBasis4Text')}</p>
          <p><strong>{t('legal.section5.importantNote')}</strong> {t('legal.section5.importantNoteText')}</p>
          <p><strong>{t('legal.section5.retentionTitle')}</strong></p>
          <p>{t('legal.section5.retentionText')}</p>
          <p><strong>{t('legal.section5.accessRightTitle')}</strong></p>
          <p>{t('legal.section5.accessRightText')}</p>
          <p><strong>{t('legal.section5.recipientsTitle')}</strong></p>
          <p>{t('legal.section5.recipientsText')}</p>
          <p>{t('legal.section5.subcontractorsText')}</p>
          <p>{t('legal.section5.consentText')}</p>
          <p>{t('legal.section5.retentionPeriodText')}</p>
          <p>{t('legal.section5.contactDataText')}</p>
          <p>{t('legal.section5.cookiesText')}</p>
          <p><strong>{t('legal.section5.rightsTitle')}</strong></p>
          <p>{t('legal.section5.right1')}</p>
          <p>{t('legal.section5.right2')}</p>
          <p>{t('legal.section5.right3')}</p>
          <p>{t('legal.section5.right4')}</p>
          <p>{t('legal.section5.right5')}</p>
          <p>{t('legal.section5.right6')}</p>
          <p>{t('legal.section5.right7')}</p>
          <p>{t('legal.section5.right8')}</p>
          <p>{t('legal.section5.exerciseRightsText')}</p>
          <p><strong>{t('legal.section5.complaintTitle')}</strong></p>
          <p>{t('legal.section5.complaintText')}</p>
          <p><strong>{t('legal.section5.defenseTitle')}</strong></p>
          <p>{t('legal.section5.defenseText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section6.title')}</h2>
          <p>{t('legal.section6.text1')}</p>
          <p><strong>{t('legal.section6.typesTitle')}</strong></p>
          <p>{t('legal.section6.necessaryCookies')}</p>
          <p>{t('legal.section6.functionalCookies')}</p>
          <p>{t('legal.section6.analyticsCookies')}</p>
          <p>{t('legal.section6.disableCookies')}</p>
          <p><strong>{t('legal.section6.managementTitle')}</strong></p>
          <p>{t('legal.section6.managementText1')}</p>
          <p>{t('legal.section6.managementText2')}</p>
          <p>{t('legal.section6.managementText3')}</p>
          <p>{t('legal.section6.refusalText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section7.title')}</h2>
          <p>{t('legal.section7.text')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section8.title')}</h2>
          <p>{t('legal.section8.text1')}</p>
          <p>{t('legal.section8.text2')}</p>
          <p>{t('legal.section8.liability1')}</p>
          <p>{t('legal.section8.liability2')}</p>
          <p>{t('legal.section8.liability3')}</p>
          <p>{t('legal.section8.liability4')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.section9.title')}</h2>
          <p>{t('legal.section9.text')}</p>
        </section>
        
        <section className="legal-section">
          <h2>{t('legal.section10.title')}</h2>
          <p>{t('legal.section10.text')}</p>
          <p>{t('legal.section10.lastUpdate')} <strong>{t('legal.section10.lastUpdateDate')}</strong></p>
        </section>
      </div>
    </div>
  );
};

export default Legal;
